import { render, staticRenderFns } from "./userMGT-whiteOrBlack-list.vue?vue&type=template&id=29906f02&scoped=true&"
import script from "./userMGT-whiteOrBlack-list.vue?vue&type=script&lang=js&"
export * from "./userMGT-whiteOrBlack-list.vue?vue&type=script&lang=js&"
import style0 from "./userMGT-whiteOrBlack-list.vue?vue&type=style&index=0&id=29906f02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29906f02",
  null
  
)

export default component.exports